// src/store/cartState.js
import { useEffect, useState } from 'react';

class CartState {
  constructor() {
    this.items = []; // { service, provider, quantity, paymentMethod }
    this.listeners = new Set();
  }

  addListener(fn) {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  notify() {
    this.listeners.forEach((fn) => fn());
  }

  addItem(service, provider) {
    const idx = this.items.findIndex((e) => e.service.id === service.id);
    if (idx >= 0) {
      this.items[idx].quantity++;
    } else {
      this.items.push({ service, provider, quantity: 1, paymentMethod: 'cash' });
    }
    this.notify();
  }

  removeItem(serviceId) {
    this.items = this.items.filter((e) => e.service.id !== serviceId);
    this.notify();
  }

  updateQuantity(serviceId, qty) {
    const idx = this.items.findIndex((e) => e.service.id === serviceId);
    if (idx >= 0) {
      if (qty <= 0) this.items.splice(idx, 1);
      else this.items[idx].quantity = qty;
      this.notify();
    }
  }

  setPaymentMethod(serviceId, method) {
    const idx = this.items.findIndex((e) => e.service.id === serviceId);
    if (idx >= 0) {
      this.items[idx].paymentMethod = method;
      this.notify();
    }
  }

  clear() {
    this.items = [];
    this.notify();
  }

  get totalCount() {
    return this.items.reduce((s, e) => s + e.quantity, 0);
  }

  get totalPrice() {
    return this.items.reduce((s, e) => s + (e.service.price || 0) * e.quantity, 0);
  }
}

// ✅ Singleton — نفس فكرة CartState._instance في Flutter
export const cartState = new CartState();

// ✅ Hook لإعادة الرندر عند تغيّر السلة (مطابق لـ addListener/notifyListeners)
export function useCart() {
  const [, forceUpdate] = useState(0);
  useEffect(() => {
    const unsub = cartState.addListener(() => forceUpdate((t) => t + 1));
    return unsub;
  }, []);
  return cartState;
}